export default __webpack_public_path__ + "static/0-77d105273d182589b46e018cf6df4b2c.jpg";